import './instagram_message_builder.js.coffee'
import '../instagram_message_story_reply.js.coffee'
Namespace 'Models.Builders'

class Models.Builders.InstagramMessageStoryReplyBuilder extends Models.Builders.InstagramMessageBuilder
  constructor: ->
    super()
    @messageText = null
    @storyUrl = null
    @storyId = null

  build: ->
    new Models.InstagramMessageStoryReply(@)
